import gsap from 'gsap';
import { is_mobile } from './utils';

function sub_menu(updateEasingScenes) {
    $(".navbox a").each(function () {
        let tween = gsap.to(this, {
            color: "#979797",
            duration: 0.2,
            paused: true
        })

        $(this).on("mouseenter touchstart", function () {
            tween.play();
        });

        $(this).on("mouseleave touchend", function (e) {
            if (e.type === "touchend") {
                gsap.delayedCall(0.3, function () {
                    tween.reverse();
                });
            } else {
                tween.reverse();
            }
        })
    });

    let $header = $('.header');
    let offset = $header.height();
    offset = is_mobile ? $header.height() + $(".main__navbox").height() : offset;
    $('.navbox a').on('click', function (e) {
        let anchor = $(this).attr('href');
        let target = $(this).is(".nav-active-flow");
        updateEasingScenes = false;

      if (anchor.substr(0, 1) === '#') {
        e.preventDefault();
        document.querySelector(anchor).scrollIntoView({block: "start", behavior: "smooth"})
        // $('html, body').animate({
        //   scrollTop: $(anchor).offset().top - offset
        // }, 500, "swing", function () {
        //
        //   updateEasingScenes = true;
        //   if (target && !isMobile) {
        //     $('html, body').animate({
        //       scrollTop: $(".main-power__sticky").offset().top - offset + wh * 0.6
        //     }, 500);
        //   }
        //
        // });
      }
    });
}

export {
    sub_menu
}
